import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import bannerApi from 'api/bannerApi';
import KTFormSelect from 'general/components/OtherKeenComponents/Forms/KTFormSelect';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AppResource from 'general/constants/AppResource';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';

DialogAddBannerCategoryView.propTypes = {
  category: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddBannerCategoryView({ category, onCancel, onDone }) {
  const [name, setName] = useState(category?.name || '');
  const [description, setDescription] = useState(category?.description || '');
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);

  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(name) || !Utils.isValid(description)) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
      return;
    }
    
    const isUpdate = category && category.id;
    const currentData = { ...category, name, description };

    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        title={isUpdate ? 'Cập nhật' : 'Thêm mới'}
        contentEl={<>Bạn có chắc chắn muốn {isUpdate ? 'cập nhật' : 'thêm mới'} danh mục này không?</>}
        cancelButtonText="Bỏ qua"
        confirmButtonText="Đồng ý"
        onCancel={() => {
          AppCustomDialogHelper.show(
            isUpdate ? 'Chỉnh sửa danh mục' : 'Thêm mới danh mục',
            <DialogAddBannerCategoryView
              category={currentData}
              onCancel={onCancel}
              onDone={onDone}
            />,
            'md', false, true, false, false
          );
        }}
        onConfirm={async () => {
          AppCustomDialogHelper.hide();
          try {
            setLoading(true);
            if (isUpdate) {
              await bannerApi.updateBannerCategory(category.id, { name, description });
              ToastHelper.showSuccess('Cập nhật danh mục thành công');
            } else {
              await bannerApi.createBannerCategory({ name, description });
              ToastHelper.showSuccess('Thêm mới danh mục thành công');
            }
            if (onDone) onDone();
          } catch (error) {
            ToastHelper.showError(isUpdate ? 'Cập nhật danh mục thất bại' : 'Thêm mới danh mục thất bại');
          } finally {
            setLoading(false);
          }
        }}
        iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
      />,
      'md', true, true
    );
  };

  return (
    <div>
      <div style={{ height: '40vh', overflowY: 'auto' }}>
        <div className="row m-0 p-0 px-2 mt-4">
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Tên danh mục', true)}
              <KTFormInput
                type={KTFormInputType.text}
                placeholder="Nhập tên danh mục"
                name="name"
                value={name}
                onChange={(value) => setName(value)}
                enableCheckValid={readyToValidate}
                isValid={Utils.isValid(name)}
                isTouched={readyToValidate}
                feedbackText="Tên danh mục không được để trống"
              />
            </div>
          </div>
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Mô tả')}
              <KTFormTextArea
                rows={3}
                placeholder="Nhập mô tả"
                name="description"
                value={description}
                onChange={(value) => setDescription(value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(category ? 'Lưu' : 'Thêm', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogAddBannerCategoryView;
